import {Menu} from 'antd';
import React, {FC} from 'react';

import {KebabMenu} from 'components/@common/widgets/kebab-menu';
import {ICustomLinkSubmenuCommonProps} from 'features/provide-custom-link/model/types';
import {TLinkDto} from 'shared/types/links';
import {isEmptyObject} from 'shared/utils';

import s from './custom-link-submenu.module.less';
import {SubmenuItem} from './submenu-item';

interface ICustomLinkSubmenuProps extends ICustomLinkSubmenuCommonProps {
    childrenCustomLinks: TLinkDto['children'];
}

export const CustomLinkSubmenu: FC<ICustomLinkSubmenuProps> = ({
    childrenCustomLinks,
    ...rest
}: ICustomLinkSubmenuProps) => (
    <KebabMenu
        button={{
            type: 'primary',
            size: 'small',
        }}
        placeholder={!childrenCustomLinks?.length ? <>Список действий пуст</> : undefined}
        overlayClassName={s.overlay}
    >
        <Menu>
            {/* Во избежание циклических зависимостей не используем CustomLink, а рендерим CustomLinkView напрямую */}
            {childrenCustomLinks?.map(childLink => !isEmptyObject(childLink) && (
                <SubmenuItem
                    link={childLink}
                    {...rest}
                />
            ))}
        </Menu>
    </KebabMenu>
);
